import ElMenu from './src/menu'

export default ElMenu
